import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const fileUrl = (id) => `${API}/files/${id}`;
export const publicMediaUrl = (slug, id) => `${API}/share/${slug}/media/${id}`;
